module.exports = __webpack_public_path__ + "img/sad.68a4b29a.svg";